import { render, staticRenderFns } from "./PodcastCard.vue?vue&type=template&id=61ccacfb"
import script from "./PodcastCard.vue?vue&type=script&lang=js"
export * from "./PodcastCard.vue?vue&type=script&lang=js"
import style0 from "./PodcastCard.vue?vue&type=style&index=0&id=61ccacfb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports